import {gql} from "@apollo/client";

export const GET_ALL_LANDLORDS = gql`
    query GetAllLandlords {
        landlords(pagedInput: {
            pageInfo: {
                pageIndex: 0,
                pageSize: 1000
            },
            orderAsc: true,
            orderField: "lastName",
            filter: {}
        }) {
            items {
                id
                firstName
                lastName
                email
            }
        }
    }
`;

export const GET_LANDLORDS = gql`
    query GetLandlords($pageIndex: Int!, $pageSize: Int!, $orderAsc: Boolean!, $orderField: String!, $filter: JSON, $propertyCountBuckets: [String!]) {
        landlords(
          pagedInput: {
            pageInfo: {
                pageIndex: $pageIndex,
                pageSize: $pageSize
            },
            orderAsc: $orderAsc,
            orderField: $orderField,
            filter: $filter
          },
          propertyCountBuckets: $propertyCountBuckets
        ) {
            items {
                id
                firstName
                lastName
                email
                primaryPhone
                secondaryPhone
                properties {
                id
            }
          }
          pageInfo {
            totalCount
            totalPages
            pageSize
            pageIndex
          }
        }     
    }
`;

export const GET_LANDLORD = gql`
    query GetLandlord($id: ID!) {
        landlord(id: $id) {
            id
            firstName
            lastName
            email
            primaryPhone
            secondaryPhone
            properties {
                id
                address {
                    street
                    suburb
                    city
                    postalCode
                }
                status
            }
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_LANDLORD = gql`
    mutation CreateLandlord($input: LandlordInput!) {
        createLandlord(inputData: $input) {
            id
            firstName
            lastName
        }
    }
`;

export const UPDATE_LANDLORD = gql`
    mutation UpdateLandlord($id: ID!, $input: LandlordInput!) {
        updateLandlord(id: $id, inputData: $input) {
            id
            firstName
            lastName
        }
    }
`;

export const DELETE_LANDLORD = gql`
    mutation DeleteLandlord($id: ID!) {
        deleteLandlord(id: $id)
    }
`;

export const GET_LANDLORD_DOCUMENTS = gql`
    query GetLandlordDocuments($id: ID!) {
        landlord(id: $id) {
            id
            firstName
            lastName
            email
            bankingDetails
            bankingDetailsInfo {
                bankName
                accountNumber
                accountType
                branchCode
                accountHolder
            }
            documents {
                id
                name
                type
                url
                uploadedAt
            }
        }
    }
`;

export const UPLOAD_DOCUMENT = gql`
    mutation UploadLandlordDocument($landlordId: ID!, $file: Upload!, $type: String!) {
        uploadLandlordDocument(landlordId: $landlordId, file: $file, type: $type) {
            id
            name
            type
            url
            uploadedAt
        }
    }
`;

export const DELETE_DOCUMENT = gql`
    mutation DeleteLandlordDocument($id: ID!) {
        deleteLandlordDocument(id: $id)
    }
`;

export const UPDATE_BANKING_DETAILS = gql`
    mutation UpdateBankingDetails($landlordId: ID!, $input: BankingDetailsInput!) {
        updateLandlordBankingDetails(landlordId: $landlordId, input: $input) {
            id
            bankName
            accountNumber
            accountType
            branchCode
            accountHolder
        }
    }
`;

